import { createIcon } from '../icon'
import JeansIcon from '../svg/JeansIcon'

export const JeansIconDefault = createIcon(JeansIcon)
